import { genericApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useWorkstationQuery = (token) =>
  useQuery({
    queryKey: ['workstations', token],
    queryFn: async () => {
      const { data } = await genericApi.getWorkstation(token)
      return data
    }
  })
